/**** session clear when user enter from menue start  ****/
jQuery(".tps_menu").click(function() {
  localStorage.clear();
});
